import { SC } from '../helper/ServerCall';

export const listService = {
    getAllListTypes,
    getListType,
    getList,
    storeList,
    editList,
    deleteList,
    getListItem,
}

function getAllListTypes() {
    return SC.getCall('list_type');
}

function getListType(id) {
    return SC.getCall('list_type' + id);
}

function getList(list_name, page, filter, sort, pageSize, component_name, pagination) {
    // return SC.getCall(`list_type/${list_name}/list?page=` + page + '&filter=' + filter + '&sort=' + sort + '&pageSize=' + pageSize);
    return SC.getCall(`list_type/${list_name}/list?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}&component_name=${component_name}&pagination=${pagination}`);

}

function getListItem(id) {
    return SC.getCall(`lists/${id}`);
}
function storeList(listData) {
    return SC.postCall('lists', listData);
}

function deleteList(list_id) {
    return SC.deleteCall('lists/' + list_id);
}

function editList(listData, list_id) {
    return SC.putCall('lists/' + list_id, listData);
}





// WEBPACK FOOTER //
// ./src/services/lists.js